module.exports = __webpack_public_path__ + "img/GS_Profile-Lucky Banda.9bc850c5.png";